import { add, format } from 'date-fns'

import { getRandomUserDetails } from '../helpers/userData.helpers'
import { PagePartialState, PersistentState } from 'directFlow/state/persistentState/type'
import { Page, StepPage } from 'directFlow/types'

import {
  EmploymentStatus,
  LicenceType,
  OvernightLocation,
  UsageType,
  VehicleFuelType,
  VehicleSteering,
  VehicleTransmission,
  VehicleType,
} from 'types'

const formProgress = (): StepPage[] => {
  return [
    Page.REGISTRATION,
    Page.MVL,
    Page.VEHICLE_FOUND,
    Page.VEHICLE,
    Page.LICENCE,
    Page.DRIVERS,
    Page.HISTORY,
    Page.PREVIOUS_CANCELLATION,
    Page.PREVIOUS_CANCELLATION_YEAR,
    Page.USAGE,
    Page.POLICY_START_DATE,
  ]
}

interface GetDirectLocalStorageStateArgs {
  quoteOverride?: PagePartialState
}

export const getDirectLocalStorageState = ({
  quoteOverride,
}: GetDirectLocalStorageStateArgs = {}): PersistentState => {
  const userDetails = getRandomUserDetails({
    customDateOfBirth: { year: '1974', month: '08', day: '26' },
    emailOptions: { passfraud: true, forceOnfido: false },
  })

  return {
    quoteGeneralInfo: {},
    formProgress: formProgress(),
    pageState: {
      registration: {
        regPlate: 'D1PLO',
      },
      manualVehicleLookup: {},
      vehicleFound: {
        abiCode: '50077908',
        groupRating: 21,
        transmission: VehicleTransmission.AUTOMATIC,
        // groupedTransmission: 'AUTOMATIC',
        model: 'Yaris',
        description: 'Yaris',
        bodyType: 'HATCHBACK',
        firstRegistrationDate: '2007-01-01',
        price: 5000,
        year: 2007,
        fuel: VehicleFuelType.PETROL,
        tracker: false,
        engineSize: 1000,
        import: false,
        numberOfSeats: 5,
        make: 'Toyota',
        grossWeight: null,
        vehicleType: VehicleType.CAR,
        steering: VehicleSteering.RHD,
      },

      vehicle: {
        purchased: false,
        modifications: { checked: false, list: [] },
        isRegisteredKeeper: true,
        isLegalOwner: true,
        drivesOtherCars: false,
        overnightLocation: OvernightLocation.CARPORT,
        mileage: 7000,
        totalCarsInHousehold: 1,
      },
      licence: {
        licenceType: LicenceType.UK_FULL,
        ukDurationYear: '2020',
        ukDurationMonth: 'February',
        hasAnotherLicence: false,
        drivingLicenceNumber: '',
        skipDrivingLicenceNumberQuestion: true,
      },
      drivers: {
        title: userDetails.title,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email,
        emailSubscribe: true,
        dateOfBirth: userDetails.dateOfBirth,
        yearsInUk: '1',
        address: {
          id: 'GB|RM|A|50399574',
          subBuilding: '4',
          buildingNumber: '15',
          buildingName: 'The Sail Lofts',
          secondaryStreet: '',
          street: 'Sea Street',
          city: 'Whitstable',
          line1: '4 The Sail Lofts',
          line2: '15 Sea Street',
          line3: '',
          line4: '',
          line5: '',
          adminAreaName: 'Kent',
          province: 'Kent',
          postalCode: 'CT5 1AN',
          countryIso2: 'GB',
          label: '4 The Sail Lofts\n15 Sea Street\nWHITSTABLE\nCT5 1AN\nUNITED KINGDOM',
        },
        homeowner: false,
        student: false,
        exitSurvey: 'Instagram',
        employment: 'MEAT INSPECTOR',
        industry: 'MEAT MARKET',
        additionalDrivers: { checked: false, list: [] },
        employmentStatus: EmploymentStatus.EMPLOYED,
        hasSecondaryEmployment: false,
        hasMedicalCondition: false,
      },
      history: {
        claims: { checked: false, list: [] },
        convictions: { checked: false, list: [] },
        nonMotoringConvictions: false,
        anyDriverPreviousInsuranceCancelled: false,
      },
      claimFreeDiscount: {
        ncd: { ukYears: 5 },
      },
      previousCancellation: {},
      previousCancellationYear: {},
      usage: {
        usageType: UsageType.SDP,
      },
      quote: { inceptionDate: format(add(new Date(), { days: 14 }), 'yyyy-MM-dd') },
      ...quoteOverride,
    },
    meta: { createdAt: new Date().toString(), version: 1 },
  }
}
